import styled from "styled-components";
import { Modal as BaseModal } from "@wrstudios/components";
import { default as BaseBadge } from "../../../common/Badge";
import { TableRow as BaseTableRow } from "../../../common/Table";

export const Container = styled.div`
  width: 100%;
  max-width: 110.1rem;
  margin: 4.8rem auto;
  padding: 0 2.4rem;

  ${({ theme }) => theme.media.sm`
    margin: 2.4rem auto;
  `}
`;

export const Header = styled.div`
  margin-bottom: 3.2rem;

  ${({ theme }) => theme.media.sm`
    margin-bottom: 2.4rem;
  `}
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

export const Title = styled.h2`
  display: flex;
  align-items: baseline;
  font-weight: 600;
  font-size: 4.8rem;
  line-height: 5.2rem;
  margin-bottom: 1.2rem;
  color: ${({ theme }) => theme.live.colors.primary};

  ${({ theme }) => theme.media.sm`
    font-size: 3.2rem;
    line-height: 3.5rem;
  `}
`;

export const Grid = styled.div`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  margin: 0 -2.4rem;

  ${({ theme }) => theme.media.sm`
    margin: 0;
  `}
`;

export const Cell = styled.div`
  padding: 0 2.4rem;

  ${({ theme }) => theme.media.sm`
    padding-left: 0;
    padding-right: 1.2rem;
  `}

  &:last-child {
    ${({ theme }) => theme.media.sm`
      padding-right: 0;
    `}
  }
`;

export const DividerCell = styled(Cell)`
  padding: 0;

  ${({ theme }) => theme.media.sm`
    display: none;
  `}
`;

export const Divider = styled.div`
  flex-shrink: 0;
  width: 0.1rem;
  height: 3.6rem;
  background-color: ${({ theme }) => theme.styleGuide.colors.gray[600]};
`;

export const SubTitle = styled.h3`
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 1.6rem;
  margin-bottom: 1.2rem;
  text-transform: uppercase;

  ${({ theme }) => theme.media.sm`
    font-size: 1.3rem;
    line-height: 1.7rem;
  `}
`;

export const Info = styled.button`
  width: 4rem;
  height: 4rem;
  margin: -0.2rem -1.3rem 0 0;
  padding: 0;
  appearance: none;
  cursor: pointer;

  svg {
    width: 1.4rem;
    height: 2rem;
    fill: ${({ theme }) => theme.styleGuide.colors.gray[900]};
  }
`;

export const Description = styled.p`
  font-weight: 600;
  font-size: 1.6rem;
  line-height: 2.2rem;
  margin: 0;

  ${({ theme }) => theme.media.sm`
    font-size: 1.7rem;
    line-height: 2.4rem;
  `}
`;

export const Value = styled.span`
  color: ${({ theme }) => theme.live.colors.primary};
`;

export const Group = styled.div`
  margin-bottom: 2.4rem;
  box-shadow: ${({ theme }) => theme.styleGuide.shadows.raised};
  background-color: ${({ theme }) => theme.styleGuide.colors.white};
  border-radius: 1.2rem;
  overflow: hidden;
`;

export const GroupTitle = styled.h2`
  display: flex;
  justify-content: space-between;
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 2.2rem;
  padding: 1.6rem;
  color: ${({ theme }) => theme.styleGuide.colors.gray[800]};

  ${({ theme }) => theme.media.sm`
    font-size: 1.7rem;
    line-height: 2.4rem;
  `}

  svg {
    fill: ${({ theme }) => theme.styleGuide.colors.gray[800]};
  }
`;

export const Badge = styled(BaseBadge)`
  margin-right: 0.8rem;
`;

export const Street = styled.button`
  font-weight: 600;
  appearance: none;
  cursor: pointer;
`;

export const CityStateZip = styled.span`
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.6rem;
  color: ${({ theme }) => theme.styleGuide.colors.gray[800]};

  ${({ theme }) => theme.media.sm`
    font-size: 1.3rem;
    line-height: 1.7rem;
  `}
`;

export const ModalContent = styled(BaseModal.Content)`
  width: 100%;
  max-width: 75.4rem;
`;

export const ModalText = styled.p`
  font-size: 1.4rem;
  line-height: 2rem;
  margin: 0 0 2.4rem;

  ${({ theme }) => theme.media.sm`
    font-size: 1 .5rem;
  `}
`;

export const Disclaimer = styled.p`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  margin: 2.4rem 0 1.6rem;
  color: #4b5563;
  text-align: center;
`;

export const ZillowLogo = styled.img`
  display: block;
  width: 6.6rem;
  height: 1.4rem;
  margin: 1.6rem auto;
`;

export const Zestimate = styled.a`
  color: inherit;
  text-decoration: none;
`;

export const TableRow = styled(BaseTableRow)`
  &:hover {
    ${Street},
    ${Zestimate} {
      text-decoration: underline;
    }
  }
`;

export const TableHeader = styled.thead`
  border-top: 0.1rem solid ${({ theme }) => theme.styleGuide.colors.gray[400]};

  ${TableRow} {
    cursor: default;
  }
`;
